"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKProgressBar = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../common");
var clsx_1 = require("clsx");
require("./GKProgressBar.css");
var GKProgressBar = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-progress-bar",
    }), _b = _a.height, height = _b === void 0 ? 5 : _b, inverse = _a.inverse, style = _a.style, _c = _a.width, width = _c === void 0 ? 150 : _c, value = _a.value, mappedProps = __rest(_a, ["height", "inverse", "style", "width", "value"]);
    var barClasses = (0, clsx_1.clsx)([
        "gk-progress-bar--bar",
        { inverse: inverse },
        value === undefined ? "indeterminate" : "determinate",
    ]);
    var normalizedVal = react_1.default.useMemo(function () {
        if (value === undefined) {
            return undefined;
        }
        return Math.max(0, Math.min(value, 100));
    }, [value]);
    return (react_1.default.createElement("div", __assign({}, mappedProps, { style: __assign(__assign({}, style), { width: width, height: height }), role: "progressbar", "aria-valuenow": normalizedVal ? Math.round(normalizedVal) : undefined }),
        react_1.default.createElement("div", { className: barClasses, "data-qa": mappedProps["data-qa"] + "--bar", style: { width: normalizedVal + "%" } })));
};
exports.GKProgressBar = GKProgressBar;
